import React, { Component } from "react";
import { connect } from "react-redux";
import { FiLock } from "react-icons/fi";
import { Alert, Button, Form, Input, Typography } from "antd";
import { removeStorageWhenLogout, setHtmlStorage } from "../../config/helper";
import * as actionAuth from "../../store/auth/action";
import styles from "./reset.module.css";

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    const getValue = window.location.search.substring(1).split("&");
    this.state = {
      token: getValue[1].replace("token=", ""),
      email: getValue[0].replace("email=", ""),
      password: "",
      conPassword: "",
      fieldPasswordShow: false,
      fieldPasswordStatus: "",
      fieldPasswordMessage: null,
      fieldConPasswordShow: false,
      fieldConPasswordStatus: "",
      fieldConPasswordMessage: null,
    };
    this.handleResetForm = this.handleResetForm.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    if (window.location.search === "") {
      removeStorageWhenLogout();
      window.location.href = "/signin";
    }
  }

  handleResetForm = async () => {
    if (this.state.password === "") {
      this.setState({
        fieldPasswordShow: true,
        fieldPasswordStatus: "error",
        fieldPasswordMessage: "This field cannot be empty.",
      });
      return;
    }
    if (
      !/(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}/.test(
        this.state.password
      )
    ) {
      this.setState({
        fieldPasswordShow: true,
        fieldPasswordStatus: "error",
        fieldPasswordMessage:
          "This field must contain at least eight characters, one number, one uppercase, one lowercase, and one non-alphanumeric (e.g @$!%*#?&).",
      });
      return;
    }
    if (this.state.conPassword === "") {
      this.setState({
        fieldConPasswordShow: true,
        fieldConPasswordStatus: "error",
        fieldConPasswordMessage: "This field cannot be empty.",
      });
      return;
    }
    if (this.state.password !== this.state.conPassword) {
      this.setState({
        fieldPasswordShow: true,
        fieldPasswordStatus: "error",
        fieldPasswordMessage:
          "The password and confirmation password do not match.",
        fieldConPasswordShow: true,
        fieldConPasswordStatus: "error",
        fieldConPasswordMessage:
          "The password and confirmation password do not match.",
      });
      return;
    }

    const payload = {
      data: JSON.stringify({
        email: this.state.email,
        token: this.state.token,
        newPassword: this.state.password,
      }),
    };

    await this.props.authReset(payload);

    if (this.props.resetResponse.httpStatus === 200) {
      setHtmlStorage("reset-message", this.props.resetResponse.data);
      window.location.href = "/reset-password/success";
    } else {
      this.setState({
        alertShow: true,
        alertVariant: "error",
        alertMessage: this.props.resetResponse.data,
      });
    }
  };

  handleInputChange = (evt) => {
    const { name, value } = evt.target;
    this.setState({
      [name]: value,
      fieldPasswordShow: false,
      fieldPasswordStatus: "",
      fieldPasswordMessage: null,
      fieldConPasswordShow: false,
      fieldConPasswordStatus: "",
      fieldConPasswordMessage: null,
    });
  };

  render() {
    return (
      <div className={styles.auth_reset_page}>
        <div className={styles.auth_wrapper}>
          <Typography.Title level={3} className={styles.auth_reset_title}>
            Create New Password
          </Typography.Title>
          {this.state.alertShow && (
            <Alert
              type={this.state.alertVariant}
              message={this.state.alertMessage}
              closable
              onClose={() => this.setState({ alertShow: false })}
            />
          )}
          <Form
            colon={false}
            autoComplete="off"
            layout="vertical"
            onFinish={this.handleResetForm}
          >
            <Form.Item
              hasFeedback={this.state.fieldPasswordShow}
              validateStatus={this.state.fieldPasswordStatus}
              help={this.state.fieldPasswordMessage}
            >
              <Input.Password
                placeholder="Password"
                name="password"
                prefix={<FiLock />}
                value={this.state.password}
                onChange={this.handleInputChange}
              />
            </Form.Item>
            <Form.Item
              hasFeedback={this.state.fieldConPasswordShow}
              validateStatus={this.state.fieldConPasswordStatus}
              help={this.state.fieldConPasswordMessage}
            >
              <Input.Password
                placeholder="Confirm Password"
                name="conPassword"
                prefix={<FiLock />}
                value={this.state.conPassword}
                onChange={this.handleInputChange}
              />
            </Form.Item>
            <Button
              loading={this.props.loading}
              disabled={this.props.loading}
              className={styles.btn_reset}
              type="primary"
              htmlType="submit"
            >
              Reset Password
            </Button>
          </Form>
        </div>
      </div>
    );
  }
}

const stateToProps = (state) => {
  const { auth } = state;
  return {
    loading: auth.loading,
    resetResponse: auth.resetResponse,
  };
};

const dispatchToProps = (dispatch) => ({
  authReset: (payload) => dispatch(actionAuth.authReset(payload)),
});

export default connect(stateToProps, dispatchToProps)(ResetPassword);
